import { Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { currentUserHasPermission } from "../../../Utils/Utilities";
import CustomizableCard from "./CustomizableCard"; // Adjust path as needed

const SuppliersCard = ({
  supplierData = {},
  onConnectionEntryOpen,
}) => {
  const navigate = useNavigate();
  const canAddConnections = currentUserHasPermission('ConnEntry');

  const sections = [
    {
      label: "Active",
      value: supplierData.active,
      color: "text-sahi-orange",
      onClick: () => navigate(`/connections?t=S&s=active`)
    },
    {
      label: "Inactive",
      value: supplierData.inactive, 
      color: "text-sahi-grey",
      onClick: () => navigate(`/connections?t=S&s=inactive`)
    },
    {
      label: "Future",
      value: supplierData.future,
      color: "text-sahi-orange",
      onClick: () => navigate(`/connections?t=S&s=future`)
    }
  ];

  return (
    <CustomizableCard
      title="Suppliers"
      icon={<Users className="md:w-5 md:h-5 w-4 h-4" />}
      iconColor="text-sahi-orange"
      sections={sections}
      onAddClick={() => onConnectionEntryOpen("Supplier")}
      showAddButton={canAddConnections}
    />
  );
};

export default SuppliersCard;